import useAxios from "./useAxios";
import UpdateRequiredScreen from "../layout/components/UpdateRequiredScreen";

/**
 * Mounts the axios response interceptor for the whole app, once.
 *
 * useAxios registers the interceptor in a useEffect and EJECTS it on cleanup, and
 * nothing mounted it at the root. On ordinary screens it was mounted only by
 * accident of layout: Layout renders TopAccountBar → ProfileAccountSheet →
 * useHandleUsers() → useAxios().
 *
 * Layout drops TopAccountBar when `hideChrome`, and when `immersiveChat` — an
 * OPEN CONVERSATION. So opening a chat thread ejected the interceptor, and with
 * it:
 *
 *   - isRevokedSession, which is what signs out an account that was suspended or
 *     deleted mid-session. authService describes the database-backed isActive
 *     check as "the only tool we have for stopping a harasser", and the server
 *     returns ACCOUNT_SUSPENDED / ACCOUNT_NOT_FOUND specifically so the client
 *     can end the session. On the chat screen nothing read those codes — the one
 *     screen where suspension needs to bite hardest.
 *   - every error snackbar. A message that failed to send showed nothing.
 *
 * Nothing looked broken, which is why it went unnoticed: the auth header is a
 * global assignment on axios.defaults that cleanup never cleared, so requests
 * kept authenticating. Only the error handling disappeared.
 *
 * Rendered above the router so its lifetime cannot depend on which route is
 * showing.
 *
 * Renders nothing, except once the API has refused this build as too old
 * (Q-31): then the full-screen "Update required" screen, which covers every
 * route and every sign-in state for the same reason.
 */
const ApiInterceptor = () => {
  const updateRequired = useAxios();
  return updateRequired ? <UpdateRequiredScreen /> : null;
};

export default ApiInterceptor;
